<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="医生姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['doctorName']" placeholder="请输入医生姓名"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="患者姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['patientName']" placeholder="请输入患者姓名"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否到院就诊" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['scflag']" placeholder="请输入是否到院就诊"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="预约日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择预约日期" v-decorator="['visitTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="流水号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['lsh']" placeholder="请输入流水号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="挂号费" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['ghf']" placeholder="请输入挂号费" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="挂号费退款" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['ghfRefound']" placeholder="请输入挂号费退款" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="挂号费退款方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['ghfRefoundType']" placeholder="请输入挂号费退款方式"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="额外费用" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['ewf']" placeholder="请输入额外费用" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="额外费用退款" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['ewfRefound']" placeholder="请输入额外费用退款" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="额外费用退款方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['ewfRefoundType']" placeholder="请输入额外费用退款方式"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="总金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['amount']" placeholder="请输入总金额" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="总退金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['refoundAmount']" placeholder="请输入总退金额" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="提现金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['txAmount']" placeholder="请输入提现金额" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="提现状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['txStatus']" placeholder="请输入提现状态"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="原因记录" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['records']" placeholder="请输入原因记录"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: 'ZztTixianForm',
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
validatorRules: {
},
        url: {
          add: "/zztTixian/zztTixian/add",
          edit: "/zztTixian/zztTixian/edit",
          queryById: "/zztTixian/zztTixian/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'doctorRegisterRecordId','doctorName','patientName','scflag','visitTime','yuefen','lsh','ghf','ghfRefound','ghfRefoundType','ewf','ewfRefound','ewfRefoundType','amount','refoundAmount','txAmount','txStatus','records'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'doctorRegisterRecordId','doctorName','patientName','scflag','visitTime','yuefen','lsh','ghf','ghfRefound','ghfRefoundType','ewf','ewfRefound','ewfRefoundType','amount','refoundAmount','txAmount','txStatus','records'))
      },
    }
  }
</script>